import { socket } from '../socket';
import { useEffect, useState } from 'react';

export function useSocketEvent(eventName, cb) {
  useEffect(() => {
    socket.on(eventName, cb);

    return () => socket.off(eventName, cb);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket.id]);
}

export function useSocketState(stateName) {
  const [currentState, updateState] = useState(null);

  useEffect(() => {
    socket.emit(`register${stateName}`);

    socket.on(`update${stateName}`, updateState);

    return () => {
      socket.off(`update${stateName}`, updateState);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket.id, stateName]);

  return [currentState];
}
